/** İletişim sayfası ve footer ile aynı Instagram profili */
export const INSTAGRAM_URL = 'https://www.instagram.com/bolenaglutensizcafe/' as const
export const WHATSAPP_NUMBER = '905449730509' as const
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}` as const
